import { ToastrService } from 'ngx-toastr';

interface QueuedError {
    message: string;
    title?: string;
    options?: any;
}

let queue: QueuedError[] = [];
let active = false;
const originalError = ToastrService.prototype.error;

ToastrService.prototype.error = function (message: string, title?: string, options?: any) {
    if (active) {
        queue.push({ message, title, options });
        return null;
    }
    active = true;
    const result = originalError.call(this, message, title, options);
    watchForDismissal(this);
    return result;
};

function watchForDismissal(instance: ToastrService) {
    const interval = setInterval(() => {
        if (!document.querySelector('.ngx-toastr.toast-error')) {
            clearInterval(interval);
            active = false;
            if (queue.length > 0) {
                const next = queue.shift()!;
                active = true;
                originalError.call(instance, next.message, next.title, next.options);
                watchForDismissal(instance);
            }
        }
    }, 200);
}
